import * as GQL from "src/types/graphql";

const EXCLUDED_FORM_STATUSES = [
  GQL.form_status_enum.Cancelled,
  GQL.form_status_enum.InProgress,
];

type FormSchoolRank = {
  sub_status: string | null;
  form: { status: GQL.form_status_enum };
  offers: { status: GQL.offer_status_enum }[];
  waitlists: { status: GQL.waitlist_status_enum }[];
};

type FormSchool = {
  schoolId: uuid | null;
};

export function canAddToWaitlists(
  formSchoolRanks: FormSchoolRank[],
  formSchools: FormSchool[],
  isAllowedSubStatus?: (subStatus: string | null) => boolean
): boolean {
  if (formSchools.some((appSchool) => !appSchool.schoolId)) {
    return false;
  }

  return formSchoolRanks.every((rank) => {
    if (EXCLUDED_FORM_STATUSES.includes(rank.form.status)) return false;
    if (isAllowedSubStatus && !isAllowedSubStatus(rank.sub_status))
      return false;

    if (
      rank.waitlists[0]?.status === GQL.waitlist_status_enum.Waitlisted ||
      (GQL.form_status_enum.Admissions === rank.form.status &&
        (rank.offers[0]?.status === GQL.offer_status_enum.Offered ||
          rank.offers[0]?.status === GQL.offer_status_enum.Accepted))
    )
      return false;

    return true;
  });
}
